import React, { useEffect, useMemo, useRef, useState } from 'react'
import './Layout4.css';


const Layout4 = ({ data }) => {

    const { canvas, video, brand, titles = [], products = [], subTitle } = data;

    const videoRef = useRef(null);
    const [mode, setMode] = useState("intro");
    const [startContentAnimation, setStartContentAnimation] = useState(false);

    useEffect(() => {

        const timer = setTimeout(() => {

            const videoEl = videoRef.current;
            if (!videoEl) return;

            const first = videoEl.getBoundingClientRect();

            setMode("normal");

            requestAnimationFrame(() => {

                const last = videoEl.getBoundingClientRect();

                const scaleX = first.width / last.width;
                const scaleY = first.height / last.height;

                const translateX = first.left - last.left;
                const translateY = first.bottom - last.bottom;

                videoEl.animate(
                    [
                        {
                            transformOrigin: "bottom left",
                            transform: `translate(${translateX}px, ${translateY}px) scale(${scaleX}, ${scaleY})`
                        },
                        {
                            transformOrigin: "bottom left",
                            transform: "translate(0px,0px) scale(1,1)"
                        }
                    ],
                    {
                        duration: 1200,
                        // easing: "cubic-bezier(0.22,1,0.36,1)",
                        easing: "cubic-bezier(0.16, 1, 0.3, 1)", // smoother easing
                        fill: "both"
                    }
                );

                // setTimeout(() => {
                setStartContentAnimation(true);
                // }, 1000);

            });

        }, 3000);

        return () => clearTimeout(timer);

    }, []);

    // --------- Filter Data ----------- //

    const filteredTitles = useMemo(
        () => (titles || []).filter(t => t && t.trim() !== ""),
        [titles]
    );

    const filteredProducts = useMemo(
        () => (products || []).filter(p => p && p.trim() !== ""),
        [products]
    );

    useEffect(() => {
        setCurrentIndex(0);
    }, [filteredTitles.length]);

    useEffect(() => {
        setCurrentImgIndex(0);
    }, [filteredProducts.length]);

    // --------- Animation States ----------- //

    const [currentIndex, setCurrentIndex] = useState(0);
    const [currentImgIndex, setCurrentImgIndex] = useState(0);
    const [animate, setAnimate] = useState(true);

    useEffect(() => {
        if (!startContentAnimation) return;

        const interval = setInterval(() => {

            // Title exit animation
            setAnimate(false);

            setTimeout(() => {

                setCurrentIndex((prev) =>
                    prev === filteredTitles.length - 1 ? 0 : prev + 1
                );

                setCurrentImgIndex((prev) =>
                    prev === filteredProducts.length - 1 ? 0 : prev + 1
                );

                setAnimate(true);

            }, 300); // title exit animation time

        }, 4000);

        return () => clearInterval(interval);

    }, [startContentAnimation, filteredTitles.length, filteredProducts.length]);


    return (
        // <div className={`layout4-container`}>
        <div className={`layout4-container ${mode}`}>

            {/* Left Section */}
            {mode !== "intro" && (
                <div className="layout4-left" style={{ backgroundColor: canvas?.sideBackgroundColor }}>

                    {/* Brand */}
                    <div className="layout4-brand">
                        {brand?.logoUrl && (
                            <img src={brand.logoUrl} alt="logo" className="layout4-logo" />
                        )}
                    </div>

                    {/* QR */}
                    <div className="layout4-qr-wrapper">
                        {brand?.qrCodeUrl ? (
                            <img src={brand.qrCodeUrl} alt="QR" className="layout4-qr" />
                        ) : (
                            <div className="layout4-qr-placeholder">QR Code</div>
                        )}
                    </div>

                    {/* Products */}
                    <div className="layout4-products">
                        {filteredProducts.length > 0 && (
                            <img
                                key={`product-${currentImgIndex}`}
                                src={filteredProducts[currentImgIndex]}
                                alt={`product-${currentImgIndex}`}
                                className="layout4-product-img"
                            />
                        )}
                    </div>
                </div>
            )}


            {/* Right section */}
            <div className='layout4-right'>
                {/* VIDEO SECTION */}
                <div ref={videoRef} className="layout4-video-section">
                    {video?.url ? (
                        <video
                            src={video.url}
                            autoPlay
                            muted
                            loop
                            playsInline
                            className="layout4-video"
                        />
                    ) : (
                        <div className="layout4-video-placeholder">
                            <div className="layout4-play">▶</div>
                            <div>Upload Video</div>
                        </div>
                    )}
                </div>

                {/* BOTTOM SECTION */}
                {mode !== "intro" && (
                    <div
                        className="layout4-bottom"
                        style={{ backgroundColor: canvas?.bottomBackgroundColor }}
                    >
                        <h1
                            className={`layout4-animated-title ${animate ? "opacity-100" : "opacity-0"}`}
                            style={{ color: canvas?.titleTextColor }}
                        >
                            {filteredTitles[currentIndex]}
                        </h1>

                        <div className="layout4-bottom-cta" style={{ backgroundColor: canvas?.sideBackgroundColor, color: canvas?.subTitleTextColor }}>
                            {subTitle}
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default Layout4